import { useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import { env } from '@repo/env';
import { usePromotionVariantContext } from './use-promotion-variant-context';
export function useSpecialOfferDeadlineAction() {
    var _a = usePromotionVariantContext(), pragmaPromotionVariant = _a.pragmaPromotionVariant, setPragmaPromotionVariant = _a.setPragmaPromotionVariant;
    var timeoutRef = useRef(null);
    var deadline = env.VITE_PRAGMA_PROMOTION_END_DATE;
    useEffect(function () {
        if (pragmaPromotionVariant === 5) {
            return;
        }
        if (pragmaPromotionVariant && [2, 4].includes(pragmaPromotionVariant)) {
            return;
        }
        var target = dayjs(deadline);
        var now = dayjs();
        var delay = target.diff(now, 'millisecond');
        if (delay <= 0) {
            setPragmaPromotionVariant(2);
        }
        else {
            timeoutRef.current = setTimeout(function () {
                setPragmaPromotionVariant(2);
            }, delay);
        }
        return function () {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
}
